<div class="column-container" data-automation-id="column-container">
  <p class="fw-bold custom-toggle">
    {{ url[0].title }}
    <img
      (click)="open = !open"
      class="d-xl-none p-1 custom-toggle-icon"
      [src]="
        open ? '/assets/icons/minus-solid.svg' : '/assets/icons/plus-solid.svg'
      "
      alt=""
    />
  </p>
  <ul
    [ngClass]="[
      'nav',
      'flex-column',
      'list-container',
      open ? 'list-container_open' : ''
    ]"
  >
    <li
      class="nav-item list-item custom-font-size"
      *ngFor="let data of nestedContent"
    >
      <digital-platform-dynamic-content-wrapper
        [config]="data"
      ></digital-platform-dynamic-content-wrapper>
    </li>
  </ul>
</div>
